import { ProjectData } from '@/types/project';
import { calculateMetrics } from '@/utils/calculations';
import { CHART_COLORS } from '@/lib/constants';
import { BaseBarChart } from '@/components/Charts/BaseBarChart';

interface RevenueVsCostChartProps {
  data: ProjectData;
}

export function RevenueVsCostChart({ data }: RevenueVsCostChartProps) {
  const { totalRevenue, totalCosts } = calculateMetrics(data);

  const chartData = [
    {
      name: 'Current Period',
      Revenue: totalRevenue,
      Costs: totalCosts,
    },
  ];

  return (
    <BaseBarChart
      data={chartData}
      dataKeys={['Revenue', 'Costs']}
      colors={[CHART_COLORS.primary, CHART_COLORS.secondary]}
    />
  );
}